"use client"

import { BrowserRouter as Router, Routes, Route } from "react-router-dom"
import MainPanel from "./components/MainPanel"
import KioskView from "./components/KioskView"

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<MainPanel />} />
        <Route path="/kiosco" element={<KioskView />} />
      </Routes>
    </Router>
  )
}

export default App
